import React, { createContext, useContext, useReducer } from 'react';
import { newsReducer, initialState, INewsState, Action } from './news-reducer';

const NewsStateContext = createContext<INewsState | undefined>(undefined);
const NewsDispatchContext = createContext<React.Dispatch<Action> | undefined>(undefined);

export const NewsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [state, dispatch] = useReducer(newsReducer, initialState);

    return (
        <NewsStateContext.Provider value={state}>
            <NewsDispatchContext.Provider value={dispatch}>
                {children}
            </NewsDispatchContext.Provider>
        </NewsStateContext.Provider>
    );
};

export const useNewsState = (): INewsState => {
    const context = useContext(NewsStateContext);
    if (!context) {
        throw new Error('useNewsState must be used within NewsProvider');
    }
    return context;
};

export const useNewsDispatch = (): React.Dispatch<Action> => {
    const context = useContext(NewsDispatchContext);
    if (!context) {
        throw new Error('useNewsDispatch must be used within NewsProvider');
    }
    return context;
};
